export default __webpack_public_path__ + "img/user-settings.cf461b.svg";